import { type UseQueryResult, useQuery } from 'react-query';
import { FairMarketValueConfigurationService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetFmvConfigTransactionType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const fmvConfigTransactionType = useQuery(
    ['getFmvConfigTransactionType'],
    async () => {
      return await handleRequest(
        FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationTransactionTypesForFmvConfiguration()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
            systemName: item.systemName ?? '',
          };
        });
      },
    }
  );

  return fmvConfigTransactionType;
};

export default useGetFmvConfigTransactionType;
